import { CountryCode } from '@agroop/api/farmoo/types';

export const unsupportedPlanetCountries: CountryCode[] = ['US', 'AU', 'CA'];
